import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, RouterEvent, NavigationEnd } from '@angular/router';

import { AuthService } from '../service/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (localStorage.getItem('accessToken')) {
			const userRole = localStorage.getItem('userRole');
			// if (route.data.role && route.data.role.indexOf(userRole) === -1) {
			// 	this.router.navigate([ '/authentication/signin' ]);
			// 	return false;
			// }
			const currentUser = JSON.parse(localStorage.getItem('currentUser'));
			if (currentUser.role_id == 9 && state.url == '/fees/fees-transactions') {
				if(route.url.length>0){
					this.router.navigate([ '/authentication/page403' ]);
				}
				else{
					this.router.navigate([ '/authentication/page403' ]);
					location.reload();
				}
			} else if (currentUser.role_id == 9 && state.url == '/fees/fee-structure-list') {
				if(route.url.length>0){
					this.router.navigate([ '/authentication/page403' ]);
				}
				else{
					this.router.navigate([ '/authentication/page403' ]);
					location.reload();
				}
			} else if (currentUser.role_id == 9 && state.url == '/fees/fee-structure-mapping-list') {
				if(route.url.length>0){
					this.router.navigate([ '/authentication/page403' ]);
				}
				else{
					this.router.navigate([ '/authentication/page403' ]);
					location.reload();
				}
			} else if (currentUser.role_id == 9 && state.url == '/fees/fees-report') {
				if(route.url.length>0){
					this.router.navigate([ '/authentication/page403' ]);
				}
				else{
					this.router.navigate([ '/authentication/page403' ]);
					location.reload();
				}
			}

			return true;
		}

		// this.router.navigate([ '/authentication/signin' ]);
		// return false;
		this.clearSessionDetails();
	}

	reInitComponent() {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.navigate([ '/authentication/page403' ]);
	}

	// method to clear user session
	clearSessionDetails() {
		this.authService.logout().subscribe((res) => {
			if (!res.success) {
				this.router.navigate([ '/authentication/signin' ]);
			}
		});
	}
}
